import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link as MuiLink,
  useTheme,
  Divider,
  Paper,
} from '@mui/material';
import { resetScroll } from '../utils/scrollUtils';

// Handle footer link click to ensure scroll reset
const handleFooterLinkClick = () => {
  // Reset scroll on next tick to ensure it happens after navigation
  setTimeout(resetScroll, 0);
};
export const CustomFooter: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        px: { xs: 0, sm: 0, md: 0, lg: 0 },
        mt: 'auto', // Push to bottom when in flex container
        pt: 4,
        pb: 4,
        width: '100%',
        marginTop: 2,
        marginBottom: { xs: 12, sm: 12, md: 2, lg: 2 },
      }}
    >
      <Paper
        elevation={1}
        sx={{
          borderRadius: 4,
          backgroundColor: 'white',
          transition: 'box-shadow 0.3s ease-in-out',
          zIndex: 0,
          '&:hover': {
            boxShadow: 3,
          },
        }}
      >
        <Container maxWidth="lg" sx={{ py: 3, px: { xs: 2, sm: 4 } }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 3,
              mb: 4,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
              <img
                src="/images/logo/wellLogo.png"
                alt="MWR Logo"
                style={{ height: '40px', objectFit: 'contain' }}
              />
              <img
                src="/images/logo/Syl_logo_3c_Full.png"
                alt="NCI Designated Cancer Center Badge"
                style={{ height: '40px', objectFit: 'contain' }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
              <MuiLink
                component={Link}
                to="/terms"
                underline="hover"
                onClick={handleFooterLinkClick}
              >
                Terms of Service
              </MuiLink>
              <Typography variant="body2" component="span">
                |
              </Typography>
              <MuiLink
                component={Link}
                to="/privacy"
                underline="hover"
                onClick={handleFooterLinkClick}
              >
                Privacy Policy
              </MuiLink>
              <Typography variant="body2" component="span">
                |
              </Typography>
              <MuiLink
                component={Link}
                to="/about"
                underline="hover"
                onClick={handleFooterLinkClick}
              >
                About Us
              </MuiLink>
              <Typography variant="body2" component="span">
                |
              </Typography>
              <MuiLink
                component={Link}
                to="/sign-in"
                underline="hover"
                onClick={handleFooterLinkClick}
              >
                Sign In
              </MuiLink>
            </Box>
          </Box>

          <Typography variant="body2" textAlign="center">
            © {new Date().getFullYear()} My Wellness Research, Sylvester Comprehensive Cancer
            Center, University of Miami
          </Typography>
        </Container>
      </Paper>
    </Box>
  );
};
